<div class="desktop-wrapper">
  <header>
    <h1 translate class="title">ONBOARDING.TITLE</h1>
    <h5 translate class="subtitle">ONBOARDING.SUB_TITLE</h5>
  </header>

  <main class="main">
    <div>
      <cc-channels-feature
        [title]="'ONBOARDING.CALL_DIRECTLY_TITLE'"
        [description]="'ONBOARDING.CALL_DIRECTLY_TEXT'"
        [imageUrl]="'assets/img/channels/feature-panel.svg'"
        >
      </cc-channels-feature>
      <cc-click-to-call-button></cc-click-to-call-button>
    </div>
    <p class="or" translate>OR</p>
    <div>
      <cc-channels-feature
        [title]="'ONBOARDING.EXTENSION_TITLE'"
        [description]="'ONBOARDING.EXTENSION_TEXT'"
        [imageUrl]="'assets/img/channels/feature-widget.svg'"
      >
      </cc-channels-feature>
      <cc-download-widget></cc-download-widget>
    </div>
    <p class="or" translate>OR</p>
    <div>
      <cc-channels-feature
        [title]="'ONBOARDING.MOBILE_TITLE'"
        [description]="'ONBOARDING.MOBILE_TEXT'"
        [imageUrl]="'assets/img/channels/feature-mobile.svg'"
      >
      </cc-channels-feature>
      <cc-mobile-store-buttons></cc-mobile-store-buttons>
    </div>
  </main>
  <cc-start-actions></cc-start-actions>
</div>

<div class="mobile-wrapper">
  <header>
    <h1 translate class="title">ONBOARDING.TITLE</h1>
    <h5 translate class="subtitle">ONBOARDING.SUB_TITLE</h5>
  </header>

  <main class="main">
    <cc-channels-feature
      [title]="'ONBOARDING.MOBILE_TITLE'"
      [description]="'ONBOARDING.MOBILE_TEXT'"
      [imageUrl]="'assets/img/channels/feature-mobile.svg'"
    >
    </cc-channels-feature>

    <cc-mobile-store-buttons></cc-mobile-store-buttons>
  </main>
</div>
